import { render, staticRenderFns } from "./RegistrarPedidoItems.vue?vue&type=template&id=6b26d40c&scoped=true&"
import script from "./RegistrarPedidoItems.vue?vue&type=script&lang=js&"
export * from "./RegistrarPedidoItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b26d40c",
  null
  
)

export default component.exports